function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M801 4l2398 0c235,0 427,192 427,427l0 3137c0,235 -192,427 -427,427l-2398 0c-235,0 -427,-192 -427,-427l0 -3137c0,-235 192,-427 427,-427zm574 1667l291 0c-26,-745 1411,-308 166,705l-3 320 308 -6 2 -213c1477,-1346 -748,-2046 -763,-806zm369 -1284l513 0c70,0 127,57 127,127l0 0c0,70 -57,127 -127,127l-513 0c-70,0 -127,-57 -127,-127l0 0c0,-70 57,-127 127,-127zm256 2697c149,0 269,120 269,269 0,149 -120,269 -269,269 -149,0 -269,-120 -269,-269 0,-149 120,-269 269,-269zm-1236 -2804l2471 0c56,0 103,46 103,103l0 3234c0,56 -46,103 -103,103l-2471 0c-56,0 -103,-46 -103,-103l0 -3234c0,-56 46,-103 103,-103z"
}));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "4000px",
    height: "4000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4000 4000",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.c5e03cdd.svg";
export { ForwardRef as ReactComponent };